/* eslint-disable import/no-unused-modules */
import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { withFilterContext } from '../hocs/filter.context.hoc'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { FilterComponentProp, ValuesChangedTuple } from '../hocs/types'
import { FuelTypeSearchFiltersCheckboxes } from '../../components/search-filters-checkbox/fuel-type-search-filters-checkboxes'

const FuelTypeProps: FilterComponentProp = {
    title: 'Fuel type',
    onValueChanged: (values, otherFilters) => {
        if (!values.includes('Electric')) {
            return [
                values,
                [
                    { filter: FilterName.battery_range_values, selected: [] },
                    { filter: FilterName.battery_charge_time_values, selected: [] },
                    { filter: FilterName.battery_quick_charge_time_values, selected: [] },
                ],
            ] as ValuesChangedTuple
        } else {
            return [values, otherFilters] as ValuesChangedTuple
        }
    },
}

export const FuelType = withFacetContext(
    FacetName.fuel_type,
    withFilterContext(FilterName.fuel_type, FuelTypeSearchFiltersCheckboxes, FuelTypeProps)
)
